import gql from 'graphql-tag';

export default ({ page, size, accountId }) => {
  return gql`
      query {
          searchSubscriptionByAccountId(page: ${page}, size: ${size}, filter: {accountId: "${accountId}"}) {
              id
              accountId
              name
              status
              category
              balanceUnitId
              effectiveDate
          }
      }
  `;
};